export default "__VITE_ASSET__Yg9Tld7l__"